import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import BaseLayout from "@/Layouts/BaseLayout";
import {Breadcrumbs} from '@mui/material';
import Link from "@/Layouts/Link";
import '@/Pages/FashionTvPhotoGallery/scss/index.scss';

class FashionTvPhotoGallery extends React.Component {
    render() {
        const newPhotosArray = new Array(161).fill(1).map((el, i) => {
            return {
                ...el,
                id: i + 1,
                imgPath: '/storage/img/fashionTvPhotoGallery/preview/' + (i + 1) + '.jpg',
                imgPathWebp: '/storage/img/fashionTvPhotoGallery/preview/' + (i + 1) + '.webp',
                imgPathOriginal: '/storage/imgNoWebp/fashionTvPhotoGallery/original/' + (i + 1) + '.jpg',
                alt: 'Fashion Tv',
                title: 'Fashion Tv',
            }
        });

        const photos = newPhotosArray.map((photo, i) => {
            return <div key={i}
                        className={`fashionTvPhotoGallery__item`}
            >
                <picture>
                    <source type={`image/webp`}
                            srcSet={photo.imgPathWebp}
                    />
                    <img className={``}
                         src={photo.imgPath}
                         alt={photo.alt}
                         title={photo.title}
                         loading={`lazy`}
                    />
                </picture>
                <a className={`download`}
                   href={photo.imgPathOriginal}
                   download
                >
                    Скачать
                </a>
            </div>
        });

        return <BaseLayout {...this.props}>
            <section className={`section`}>
                <div className={`breadcrumbs`}>
                    <div className="container">
                        <Breadcrumbs
                            maxItems={2}
                            itemsAfterCollapse={2}
                        >
                            <Link className="breadcrumbs__link" href={`/`}>
                                Главная
                            </Link>
                            <p className="breadcrumbs__text">
                                Fashion Summer Awards 2022
                            </p>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className={`container`}>
                    <h1 className={`h1`}>Фотографии проекта «С заботой о природе» (Fashion Summer Awards 2022)</h1>
                    <div className={`fashionTvPhotoGallery`}>
                        {photos}
                    </div>
                </div>
            </section>
        </BaseLayout>
    }
}

export default useWithStore(FashionTvPhotoGallery);

